import { render, staticRenderFns } from "./RemoteMonitoringMessagesTemplates.vue?vue&type=template&id=0fe4efc2"
import script from "./RemoteMonitoringMessagesTemplates.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringMessagesTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports